import { HttpClient } from "@angular/common/http";
import { TranslateLoader, TranslateModuleConfig } from "@ngx-translate/core";
import { Observable, of } from "rxjs";
import { SDPTranslationStorage } from "./translation-storage";

// static loader (load ENG resources)
export class WebpackTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient, public prefix: string = "/assets/i18n/", public suffix: string = ".json",
    private _translationStorage: SDPTranslationStorage) { }

  getTranslation(lang: string): Observable<any> {
    //if (lang === 'en-US') {
    //  return observableOf(enLang.default);
    // }

    if (this._translationStorage.getItem('lang-' + lang)) {
      return of(JSON.parse(this._translationStorage.getItem('lang-' + lang)));
    }

    return this.http.get(`${this.prefix}${lang}${this.suffix}`);
  }
}


// config
export const SABISTranslateConfig: TranslateModuleConfig = {
  loader: {
    provide: TranslateLoader,
    useFactory: (http: HttpClient, _translationStorage: SDPTranslationStorage) => {
      return new WebpackTranslateLoader(http, './assets/i18n/', '.json', _translationStorage);
    },
    deps: [HttpClient, SDPTranslationStorage]
  }
};
